(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-tab-collections"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.tabs-wrapper li').forEach(tab => {
  tab.addEventListener('click', function () {
    const target = this.getAttribute('data-target');

    // Get parent UL and all LI tabs inside it
    const parentUl = this.parentElement;
    const tabs = parentUl.querySelectorAll('li');

    // Toggle active class on tabs
    tabs.forEach(t => {
      if (t.getAttribute('data-target') === target) {
        t.classList.add('active', 'button-primary');
        t.classList.remove('button-secondary');
      } else {
        t.classList.remove('active', 'button-primary');
        t.classList.add('button-secondary');
      }
    });

    // Find related wrapper
    const wrapper = this.closest('.collection-list-wrapper');
    const slides = wrapper.querySelectorAll('slideshow-component');

    // Show/Hide slides
    slides.forEach(slide => {
      if (slide.getAttribute('data-for') === target) {
        slide.style.display = '';
      } else {
        slide.style.display = 'none';
      }
    });
  });
});

// Mobile dropdown change handler
$("body").on("click", ".custom-sortby", function (event) {
  event.stopPropagation();
  const $this = $(this);

  // Toggle dropdown
  $(".custom-sortby").not($this).removeClass("active").find("ul").hide();
  $this.toggleClass("active");
  $this.find("ul").toggle();
});

// Handle option click
$("body").on("click", ".custom-sortby li", function (event) {
  event.stopPropagation();

  const targetVal = $(this).attr("data-val"); // collection.handle
  const targetLabel = $(this).text().trim(); // collection.title
  const $sortby = $(this).closest(".custom-sortby");

  // Update the active sort text
  $sortby.find(".active-sort").contents().first()[0].textContent = targetLabel;

  // Hide dropdown
  $sortby.removeClass("active").find("ul").hide();

  // Get wrapper and slides
  const wrapper = this.closest('.collection-list-wrapper');
  const slides = wrapper.querySelectorAll('slideshow-component');
  slides.forEach(slide => {
    slide.style.display = slide.getAttribute('data-for') === targetVal ? '' : 'none';
  });

  // Sync desktop tabs (if needed)
  // const $desktopTabs = $wrapper.find(".product-tab-li");
  // $desktopTabs.each(function () {
  //   if ($(this).attr("data-target") === targetVal) {
  //     $(this).addClass("active button-primary").removeClass("button-secondary");
  //   } else {
  //     $(this).removeClass("active button-primary").addClass("button-secondary");
  //   }
  // });
});

// Close dropdown on outside click
$("body").on("click", function () {
  $(".custom-sortby ul").hide();
  $(".custom-sortby").removeClass("active");
});





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
